import React from 'react';
import PropTypes from 'prop-types';
import StackChartItem from './StackChartItem';

const chartHeight = 194;

const totalField = 'total';

class StackChart extends React.PureComponent {
  render() {
    const { data, titles } = this.props;
    const leftTitles = titles.concat().splice(0, Math.floor(titles.length / 2));
    const rightTitles = titles
      .concat()
      .splice(Math.floor(titles.length / 2), titles.length);

    return (
      <div
        className="stack-chart d-flex justify-content-end"
        style={{ height: chartHeight }}
      >
        <div className="column h-100 d-flex flex-column">
          {leftTitles.map((item, index) => (
            <StackChartItem
              color={item.color}
              total={data[totalField]}
              data={data}
              item={item}
              key={index}
            />
          ))}
        </div>

        <div className="column h-100 d-flex flex-column">
          {rightTitles.map((item, index) => (
            <StackChartItem
              color={item.color}
              total={data[totalField]}
              data={data}
              item={item}
              key={index}
            />
          ))}
        </div>
      </div>
    );
  }
}

StackChart.propTypes = {
  data: PropTypes.object.isRequired,
  titles: PropTypes.array.isRequired,
};

export default StackChart;
